<template>
    <div class="cigo-tip-progress">
        <div class="title-area">
            <span>{{layerData.title}}</span>
        </div>
        <div class="progress-area">
            <cigo-icon-font
                v-if="percent < 100"
                class="progress-icon in_progress"
                name="cigoadmin-icon-jiazai"
            ></cigo-icon-font>
            <cigo-icon-font
                v-if="percent == 100"
                class="progress-icon success"
                name="cigoadmin-icon-success"
            ></cigo-icon-font>
            <a-progress class="progress-bar" :percent="percent"></a-progress>
        </div>
        <div class="progress-tips">
            <span class="tip-msg" v-for="(tip, index) in tips" :key="index">{{tip}}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, toRef } from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";

export default defineComponent({
    name: "CigoTipProgress",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let percent = toRef(props.layerData, "percent");
        let tips = toRef(props.layerData, "tips");
        return { percent, tips };
    }
});
</script>

<style lang="scss">
.cigo-tip-progress {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title-area {
        background-color: #f5f5f5;
        border-bottom: 1px solid #f0f0f0;
        padding: 15px 12px;
        display: flex;
        width: 100%;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        flex-direction: row;
        justify-content: center;
        font-size: 16px;
    }

    .progress-area {
        width: 100%;
        border-bottom: 1px solid #f0f0f0;
        padding: 20px 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .progress-icon {
            width: 100px;
            height: 100px;
            align-self: center;
            margin-bottom: 25px;
            display: none;
        }
        .progress-icon.in_progress {
            display: flex;
            -webkit-animation: playBTN 1.5s infinite linear;
            animation: playBTN 1.5s infinite linear;
        }
        .progress-icon.success {
            display: flex;
            -moz-transition: all 0.5s ease-in-out;
            -webkit-transition: all 0.5s ease-in-out;
            -o-transition: all 0.5s ease-in-out;
            -ms-transition: all 0.5s ease-in-out;
            transition: all 0.5s ease-in-out;
        }

        @-webkit-keyframes playBTN {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            100% {
                -webkit-transform: rotate(358deg);
                transform: rotate(358deg);
            }
        }
        @keyframes playBTN {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            100% {
                -webkit-transform: rotate(358deg);
                transform: rotate(358deg);
            }
        }

        .progress-bar{
            width: 90%;
            align-self: center;
        }
    }

    .progress-tips {
        display: flex;
        width: 100%;
        flex: 1;
        flex-direction: column;
        padding: 15px 12px;
        overflow-x: hidden;
        overflow-y: scroll;

        .tip-msg {
            color: #757575;
            font-size: 14px;
        }
    }

    .progress-tips::-webkit-scrollbar {
        width: 0;
    }
}
</style>
